import TableCompany from "../TableCompany";

export const TableItems = (
  filteredDataCount,
  company,
  filteredData,
  paginatedData,
  tabKey,
  setFilteredData,
  selectedRow,
  setSelectedRow
) => {
  return [
    {
      label: `All (${filteredDataCount["all"]})`,
      key: "all",
      children: (
        <TableCompany
          source={company}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
    {
      label: `Active (${filteredDataCount[1]})`,
      key: 1,
      children: (
        <TableCompany
          source={company}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
    {
      label: `Suspended (${filteredDataCount[2]})`,
      key: 2,
      children: (
        <TableCompany
          source={company}
          filteredData={filteredData}
          paginatedData={paginatedData}
          tabKey={tabKey}
          setFilteredData={setFilteredData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      ),
    },
    // {
    //   label: `Terminated (${filteredDataCount[0]})`,
    //   key: 0,
    //   children: (
    //     <TableCompany
    //       filteredData={filteredData}
    //       paginatedData={paginatedData}
    //       tabKey={tabKey}
    //       setFilteredData={setFilteredData}
    //       selectedRow={selectedRow}
    //       setSelectedRow={setSelectedRow}
    //     />
    //   ),
    // },
  ];
};
